/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { useRef, useEffect } from 'react';

function usePrevious(state) {
  var ref = useRef();
  useEffect(function () {
    ref.current = state;
  });
  return ref.current;
}

export { usePrevious as default };
//# sourceMappingURL=usePrevious.js.map
